import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import JourneySearchWeb from "./layouts/JourneySearch.web";
import JourneySearchMob from "./layouts/JourneySearch.mobile";
import flightsHero from "src/assets/images/SearchPages/flights.png";

const FlightsMainPageComponent = withConditionalComponent(JourneySearchWeb, JourneySearchMob);

export default function JourneySearch() {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <FlightsMainPageComponent trigger={isLargeScreen} props={{ imgUrl: flightsHero }} />;
}
